import React from "react";

function Git() {
	return (
		<div className='gitIcons'>
			<a
				className='github-button'
				href='https://github.com/akashraj9828/svg-text-animation-generator/fork'
				data-icon='octicon-repo-forked'
				data-size='large'
				data-show-count='true'
				aria-label='Fork akashraj9828/svg-text-animation-generator on GitHub'
			>
				Fork
			</a>
			<a
				className='github-button'
				href='https://github.com/akashraj9828/svg-text-animation-generator'
				data-icon='octicon-star'
				data-size='large'
				data-show-count='true'
				aria-label='Star akashraj9828/svg-text-animation-generator on GitHub'
			>
				Star
			</a>
			<a
				className='github-button'
				href='https://github.com/akashraj9828'
				data-size='large'
				data-show-count='true'
				aria-label='Follow @akashraj9828 on GitHub'
			>
				Follow @akashraj9828
			</a>
		</div>
	);
}

export default Git;
